import { ConfirmDialogContext } from "src/components/common/dialogs/confirmDialog/ConfirmDialogProvider.tsx";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export const useConfirmDialog = () => useContextOrThrow(ConfirmDialogContext);
